<template>
  <div>
    <nav id="sub">
      <div class="subnav-txt col-4-3">
        <h1>{{ routeTitle }}</h1>
        <p>{{ routeHeading }}</p>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'Event',
  props: {
    routeTitle: {
      type: String,
      default: '',
    },
    routeHeading: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less">

#EventsNavigation {
  .InfoPanel {
    width: 50%;
    float: right;
    position: relative;
    text-align: center;
    margin: 0 auto;

    .Modal-container {
      text-align: left;
    }
  }

  /* TODO*/

  .Form-field {
    select,
    input {
      min-width: 0;
      width: 100%;
    }

    label {
      display: block;
      min-width: unset;
    }

  }

  /*Temp Styles tyo be removed*/

  .Form-group {
    display: flex;
    width: 100%;

    .Form-field {
      width: 50%;
      margin-left: -1px;

      .Form-select,
      .Form-input {
        border-radius: 0;
        position: relative;

        &:hover, &:focus {
          z-index: 1;
        }
      }

      &:first-child:not(:last-child) {
        .Form-select,
        .dropdown-toggle,
        .Form-input {
          border-radius: 3px 0 0 3px;
        }
      }

      &:last-child:not(:first-child) {
        .Form-select,
        .dropdown-toggle,
        .Form-input {
          border-radius: 0 03px 3px 0;
        }
      }
    }
  }

  .Section--flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    &::before,
    &::after {
      display: none;
    }
  }
}
</style>
